<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>
                        {{ "AreYouSureYouWantToChange" | localize }}
                    </span>
                    <span class="highlight-user">
                        {{
                            options?.staff?.firstName +
                                " " +
                                options?.staff?.lastName
                        }}
                    </span>
                    <span>
                        {{ "RoleFrom" | localize }}
                    </span>
                    <span>{{ this.options?.oldRole }}</span>
                    <span>
                        {{ "To" | localize }}
                    </span>
                    <span>{{ this.options?.newRole }}</span>
                </h4>
            </div>

            <div class="footer">
                <button
                    (click)="close()"
                    class="btn font-weight-bold"
                    type="button"
                >
                    {{ "Cancel" | localize }}
                </button>
                <button
                    (click)="change()"
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                    {{ "Change" | localize }}
                </button>
            </div>
        </div>
    </div>
</div>
